
const getElementHeight = (element: HTMLElement):number => {
  const currentStyle = window.getComputedStyle(element)
  const marginTop = parseInt(currentStyle.marginTop)
  const marginBottom = parseInt(currentStyle.marginBottom)
  return element.offsetHeight + marginTop + marginBottom
}

export const smallTilesShowAll = ():void => {
  const showAllButtons = document.querySelectorAll('.js-smallTiles-showAll') as unknown as HTMLElement[]

  const toggleShowAll = (showAllButton: HTMLElement) => {
    const tilesComponent = showAllButton.closest('.js-smallTiles') as HTMLElement
    const tilesRow = tilesComponent.querySelector('.js-smallTiles-tileRow') as HTMLElement

    const baseRowHeight = tilesRow.clientHeight

    const showAllButtonWrapper = showAllButton.closest('.js-buttonWrapper') as HTMLElement
    showAllButtonWrapper.style.opacity = '0'
    showAllButtonWrapper.style.transform = 'translateX(100%) scale(0)'

    tilesRow.style.overflow = 'hidden'

    tilesRow.style.height = `${baseRowHeight}px`
    tilesRow.classList.remove('-toggle')

    setTimeout(() => {
      tilesRow.style.height = `${tilesRow.scrollHeight}px`
      tilesComponent.classList.remove('-noButton')
    }, 100)

    setTimeout(() => {
      showAllButton.remove()
      tilesRow.style.height = 'auto'
    }, 800)
  }

  // Listen to all button triggers
  showAllButtons.forEach((showAllButton: HTMLElement) => {
    showAllButton.addEventListener('click', (event: Event) => {
      event.preventDefault()
      toggleShowAll(showAllButton)
    })
  })
}

export const smallTilesDynamicHeight = ():void => {
  const allSmallTileRows = document.querySelectorAll('.js-smallTiles-tileRow.-toggle') as unknown as HTMLElement[]

  const adjustRowHeight = (row: HTMLElement) => {
    if (row.classList.contains('-toggle')) {
      let customHeight = 0

      setTimeout(() => {
        const firstChild = row.firstElementChild as unknown as HTMLElement
        const secondChild = (firstChild.nextElementSibling) as unknown as HTMLElement || false
        const thirdChild = (secondChild && secondChild.nextElementSibling) ? secondChild.nextElementSibling as unknown as HTMLElement : false
        const fourthChild = (thirdChild && thirdChild.nextElementSibling) ? thirdChild.nextElementSibling as unknown as HTMLElement : false

        const windowWidth = window.innerWidth

        const firstElementHeight = getElementHeight(firstChild)
        const secondElementHeight = (secondChild) ? getElementHeight(secondChild) : 0
        const thirdElementHeight = (thirdChild) ? getElementHeight(thirdChild) : 0
        const fourthElementHeight = (fourthChild) ? getElementHeight(fourthChild) : 0

        // LG/XL size
        if (windowWidth >= 1080) {
          customHeight = firstElementHeight
        }

        // MD/SM size
        if (windowWidth < 1080 && windowWidth >= 768) {
          customHeight = firstElementHeight + secondElementHeight
        }

        // XS size
        if (windowWidth < 768) {
          customHeight = firstElementHeight + secondElementHeight + thirdElementHeight + fourthElementHeight
        }

        row.style.height = `${customHeight}px`
      }, 100)
    }
  }

  // Handle all rows
  allSmallTileRows.forEach((row: HTMLElement) => {
    window.addEventListener('resize', () => {
      adjustRowHeight(row)

      setTimeout(() => {
        adjustRowHeight(row)
      }, 600)
    })
    adjustRowHeight(row)
  })
}
